export default __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-3-f918d1ec4a437fc6ea5b4df97dcd757c.png";